import {motion} from 'framer-motion';
import {SanityNavigation} from '../../../types';
import NavigationLink from './NavigationLink';

export default function NavigationMain(navigation: SanityNavigation) {
  const container = {
    hidden: {opacity: 0, y: -5},
    show: {
      opacity: 1,
      y: 0,
      transition: {
        delayChildren: 0.1,
        staggerChildren: 0.1,
        duration: 0.7,
        ease: 'easeOut',
      },
    },
  };

  const item = {
    hidden: {opacity: 0},
    show: {opacity: 1},
  };

  return (
    <div className="flex-grow px-4 md:px-0 md:pl-8">
      <motion.div className="grid gap-12 py-5">
        <div className="flex items-start justify-between">
          <motion.div
            variants={container}
            initial="hidden"
            animate="show"
            className="w-full font-kormelink"
          >
            {navigation.overlayNavigation?.main.map((element) => (
              <motion.div
                key={element._key}
                variants={item}
                className="mb-1 text-main-navigation"
              >
                <NavigationLink link={element} />
              </motion.div>
            ))}
          </motion.div>
        </div>
        <div className="grid gap-8 md:grid-cols-2 md:gap-2">
          {navigation.overlayNavigation?.sections.map((section) => (
            <motion.ul
              key={section._key}
              variants={container}
              initial="hidden"
              animate="show"
              className="text-lg leading-[1.5]"
            >
              <p className="mb-2 text-xs text-neutral-500">{section.label}</p>
              {section.links.map((element) => (
                <motion.li key={element._key} variants={item}>
                  <NavigationLink link={element} />
                </motion.li>
              ))}
            </motion.ul>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
